module.exports = __webpack_public_path__ + "img/musa.441c4186.jpg";